// ── 페이지·행 카드 스타일 ─────────────────────────────────────────────────────
// 페이지 헤더·주요 버튼은 adminlayout/designStandard 표준 토큰 사용 (2026-08 통일).

// 카드 (검색/목록) — 본문 in-flow 카드: 그림자 없음, 1px 테두리 (디자인 표준)
export const cardStyle = {
  background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)',
  boxShadow: 'none', padding: '16px 20px',
};
// 겉 박스 없는 섹션 — 계약 관리의 검색·계약완료 목록 (2026-09-16 사용자 요청: 회색 선 박스 제거).
//   계약취소 관리는 위 cardStyle 을 그대로 쓴다. 모바일은 화면 가장자리에 붙지 않게 좌우 여백만 남긴다.
export const plainSectionStyle = (isMobile) => ({
  minWidth: 0,
  ...(isMobile && { paddingInline: 16 }),
});

// 검색 구역: 아래 계약완료 목록과 50px 띄운다 — 출퇴근 관리의 '이름 검색 칸 → 상태 배지 줄' 과 같은 간격
//   (2026-09-16 사용자 요청, 실측 50px). 페이지 칸 간격 16px + 34px = 50px. 데스크톱·모바일 동일.
export const searchSectionStyle = (isMobile) => ({
  ...plainSectionStyle(isMobile),
  marginBottom: 34,
});
export const cardTitleBarStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12,
};
export const cardLabelStyle = {
  fontSize: 11, fontWeight: 700, color: 'var(--text-muted)',
  textTransform: 'uppercase', letterSpacing: '0.06em',
};

// 검색 행
export const searchRowStyle   = { display: 'flex', gap: 8, flexWrap: 'wrap' };
export const searchInputStyle = {
  flex: 1, minWidth: 180, border: '1px solid var(--border)', borderRadius: 8,
  padding: '8px 12px', fontSize: 13, color: 'var(--text)', outline: 'none',
  background: 'var(--bg-card)',  // 다크모드: 브라우저 기본 흰 배경 방지
};
export const resultCountStyle = { fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 8 };
export const emptyStyle       = { textAlign: 'center', padding: '24px 0', color: 'var(--text-muted)', fontSize: 13 };

// 행 배경색 헬퍼
// 라이트: 은은한 rgba 틴트 / 다크: 불투명도 높여 구분 가능하게
// 우선순위: cancelled(분홍) > hasShipped(녹색) > 기본
export function resolveRowColors(isContracted, isCancelled, hasShipped, isDark) {
  const d = isDark;
  if (isCancelled)   return { bg: d ? 'rgba(244,63,94,0.22)'  : 'rgba(244,63,94,0.07)',  border: d ? 'rgba(244,63,94,0.50)'  : 'rgba(244,63,94,0.25)',  left: '#f43f5e' };
  if (!isContracted) return { bg: 'var(--bg-subtle)',           border: 'var(--border)',                                                                   left: 'var(--border)' };
  if (hasShipped)    return { bg: d ? 'rgba(22,163,74,0.22)'  : 'rgba(22,163,74,0.07)',  border: d ? 'rgba(22,163,74,0.50)'  : 'rgba(22,163,74,0.25)',  left: '#16a34a' };
  return { bg: 'var(--bg-card)', border: 'var(--border)', left: 'var(--border)' };
}

// 행 카드 — 모바일
export const rowCardStyle = (isContracted, isCancelled, hasShipped, isDark) => {
  const c = resolveRowColors(isContracted, isCancelled, hasShipped, isDark);
  return {
    background: c.bg, border: `1px solid ${c.border}`,
    borderLeft: `4px solid ${c.left}`, borderRadius: 10,
    padding: '12px 14px', display: 'grid', gap: 6,
  };
};
// 행 카드 — 데스크톱 1줄 compact
// minWidth: 0 필수 — grid 자식 기본값 auto면 내용 너비만큼 늘어나 화면 밖으로 벗어남
export const rowCardDesktopStyle = (isContracted, isCancelled, hasShipped, isDark) => {
  const c = resolveRowColors(isContracted, isCancelled, hasShipped, isDark);
  return {
    background: c.bg, border: `1px solid ${c.border}`,
    borderLeft: `4px solid ${c.left}`, borderRadius: 8,
    padding: '6px 10px', display: 'flex', alignItems: 'center', gap: 8,
    minWidth: 0, overflow: 'hidden',
  };
};
export const desktopRowInner = {
  display: 'flex', alignItems: 'center', gap: 7,
  flex: 1, minWidth: 0, flexWrap: 'nowrap', overflow: 'hidden',
  whiteSpace: 'nowrap',  // 자식 요소 텍스트 줄바꿈 방지 (상속) — 행 높이가 1줄로 고정됨
};
export const desktopCompanyStyle = { fontSize: 13, color: 'var(--text)', fontWeight: 700, flexShrink: 0 };
export const desktopDivider      = {
  display: 'inline-block', width: 1, height: 12,
  background: 'var(--border)', flexShrink: 0, alignSelf: 'center',
};
// var(--text-muted)는 다크모드에서 #4b5878(어두움)으로 뒤집혀 배경과 묻힘 → var(--text-sub) 사용
export const desktopInfoChip = { fontSize: 11, color: 'var(--text-sub)' };

// 모바일 전용
export const rowTopStyle     = { display: 'flex', flexDirection: 'column', gap: 2 };
export const rowCompanyStyle = { fontSize: 15, color: 'var(--text)' };
export const infoGridStyle   = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' };
export const infoLabel       = {
  fontSize: 10, fontWeight: 700, color: 'var(--text-muted)',
  textTransform: 'uppercase', letterSpacing: '0.04em',
};
export const infoValue      = { fontSize: 12, color: 'var(--text-sub)' };
export const resultRowStyle = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6 };

export const contractedBadge = {
  background: '#16a34a', color: '#fff', fontSize: 11, fontWeight: 700,
  borderRadius: 6, padding: '2px 8px',
};
// 계약취소 상태 배지 (주황)
export const cancelledBadge = {
  background: '#d97706', color: '#fff', fontSize: 11, fontWeight: 700,
  borderRadius: 6, padding: '2px 8px',
};
export const contractDetailStyle = { fontSize: 12, color: '#166534', fontWeight: 600 };
export const serviceBadge = {
  fontSize: 12, color: '#1d4ed8', fontWeight: 600,
  background: '#eff6ff', borderRadius: 5, padding: '2px 6px',
};
export const feedbackBadge = {
  background: 'var(--bg-subtle)', color: 'var(--text-sub)', fontSize: 11, fontWeight: 700,
  borderRadius: 6, padding: '2px 8px',
};
export const reorderBtnStyle = {
  border: '1px solid #d97706', borderRadius: 8, padding: '5px 12px',
  background: '#fffbeb', color: '#92400e',
  fontWeight: 700, fontSize: 12, cursor: 'pointer',
};
// 미계약 행 CTA(계약 등록)=검정(표준 stdBlackBtn 톤), 계약완료 행=흰 외곽선(보조)
export const editBtnStyle = (isContracted) => ({
  border:     `1px solid ${isContracted ? 'var(--border)' : 'var(--std-btn, #0f172a)'}`,
  borderRadius: 8, padding: '5px 14px',
  background: isContracted ? 'var(--bg-card)' : 'var(--std-btn, #0f172a)',
  color:      isContracted ? 'var(--text-sub)' : '#fff',
  fontWeight: 700, fontSize: 12, cursor: 'pointer',
});
// 계약삭제 버튼 (빨간 테두리)
export const deleteContractBtnStyle = {
  border: '1px solid #ef4444', borderRadius: 8, padding: '5px 12px',
  background: 'var(--bg-card)', color: '#dc2626',
  fontWeight: 700, fontSize: 12, cursor: 'pointer',
};
// 이력 버튼 (회색 테두리)
export const historyBtnStyle = {
  border: '1px solid var(--border)', borderRadius: 8, padding: '5px 10px',
  background: 'var(--bg-subtle)', color: 'var(--text-sub)',
  fontWeight: 600, fontSize: 12, cursor: 'pointer',
};
